// The earnings table itself. Relative to the `affiliate` base URL.
export const EARNINGS_ENDPOINTS = {
    monthlyBreakdown: (publisherId) => `v1/accounts/${publisherId}/earnings/monthly-breakdown`
};

export const EARNINGS_DEFAULT_LIMIT = 10;

// Tax invoice upload, driven from the earnings table's action column. The file
// goes to the shared uploads service first and is attached to the invoice in a
// second call, the same two-step shape the brand contract upload uses — so a
// picked file is never attached to anything until the publisher confirms it.
export const INVOICE_ENDPOINTS = {
    // Shared `base` uploads service, not the affiliate API.
    upload  : "/uploads/v1",
    // Relative to the `affiliate` base URL.
    document: (publisherId, invoiceId) => `v1/accounts/${publisherId}/invoices/${invoiceId}/document`
};

export const INVOICE_UPLOAD_TYPE = "invoice_doc";

// Matches the server's own upload limit (UPLOAD_MAX_FILE_SIZE_MB).
export const INVOICE_MAX_SIZE_MB = 10;

// Extensions are checked alongside MIME types because scanned invoices
// frequently arrive with an empty or generic `file.type`.
export const INVOICE_MIME_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/png"
];

export const INVOICE_EXTENSIONS = [".pdf", ".jpg", ".jpeg", ".png"];

export const INVOICE_ACCEPT_ATTR = [...INVOICE_MIME_TYPES, ...INVOICE_EXTENSIONS].join(",");

// A paid invoice is closed: its document can be read back but never replaced.
export const PAID_STATUS = "paid";

export const CONFIRM_TITLE = "Attach this tax invoice?";

export const CONFIRM_NOTE = {
    FIRST  : "This document is attached to the invoice and is what the brand and NookPay ops read as your tax invoice for this payout.",
    REPLACE: "This replaces the tax invoice currently attached to this invoice. The earlier document is no longer visible to the brand or to NookPay ops."
};

export const PREVIEW_KIND = {
    PDF  : "pdf",
    IMAGE: "image"
};

export const UPLOAD_LABEL = {
    UPLOAD : "Upload tax invoice",
    REPLACE: "Replace tax invoice",
    VIEW   : "View tax invoice"
};

// Why the upload button is unavailable, so the row explains itself instead of
// showing a dead control.
export const DISABLED_REASON = {
    PAID   : "A paid invoice's tax invoice cannot be changed.",
    MISSING: "This row has no invoice reference to attach a document to."
};
